import { linearColor } from "../tools";

const Aecharts = a => require(['@/components/Aecharts'], a);

export default {
  name: 'BeMix',
  props: {
    data: {
      type: Array,
      default: () => [
        { name: 'xxxx动力1', type: 'bar', data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3] },
        { name: 'xxxx动力2', type: 'bar', data: [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3] },
        { name: '平均', type: 'line', data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2] },
        { name: '平均测试', type: 'line', yAxisIndex: 1, data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2] },
      ],
    },
    smooth: { type: Boolean, default: () => true },
    xAxis: { type: Array, default: () => ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'] },
    grid: { type: Array, default: () => [] },
    cols: { type: String | Number, default: () => '' },
    color: { type: String, default: () => '#aaa' },
    fontSize: { type: String | Number, default: () => '12' },
    textStyle: { type: Object, default: () => ({}) },
    itemStyle: { type: Object, default: () => ({}) },
    legend: { type: Object, default: () => ({ show: true, left: 'right' }) },
    showTooltip: { type: Boolean, default: () => true },
    scrollOption: { type: Object, default: () => ({ height: 20 }) },
    backgroundColor: { type: String, default: () => 'rgba(0, 0, 0, 0)' },
  },
  data() {
    return {
      option: null,
      styles: {
        textStyle: {
          color: this.color,
          fontSize: parseInt(this.fontSize),
          ...this.textStyle,
        },
      },
    }
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.create();
      },
    },
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      let series = this.data.length > 0 && this.data.map(a => ({
        name: a.name || a.text || a.label || a.title || '匿名',
        data: a.data || a.value || a.number || '0',
        itemStyle: {
          normal: {
            barBorderRadius: [15, 15, 0, 0], // 柱形图圆角，初始化效果
            color: a.color ? (Array.isArray(a.color) ? linearColor(...a.color) : linearColor(rgba(0, 0, 0, 0), a.color)) : null,
          }
        },
        barWidth: 18,
        ...a,
      }));
      this.option = {
        legend: {
          data: this.data.map(a => (a.name || a.text || a.label || a.title || '匿名')),
          ...this.styles,
          ...this.legend,
        },
        grid: {
          show: false,
          top: (this.legend && this.legend.show) ? ((parseInt(this.fontSize) * 2.5).toFixed(2)) : parseInt(this.grid[0] || 0),
          right: parseInt(this.grid[1] || this.grid[0] || 0),
          bottom: parseInt(this.grid[2] || this.grid[0] || 0),
          left: parseInt(this.grid[3] || this.grid[1] || this.grid[0] || 0),
          containLabel: true,
          ...this.styles,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        xAxis: [
          {
            type: 'category',
            data: this.xAxis,
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              ...this.styles,
            },
          }
        ],
        yAxis: [
          {
            axisLine: { show: true },
            splitLine: { show: false },
            splitArea: { show: false },
            axisLabel: {
              ...this.styles,
            },
          },
          {
            axisLine: { show: true },
            splitLine: { show: false },
            splitArea: { show: false },
            axisLabel: {
              ...this.styles,
            },
          },
        ],
        series,
        dataZoom: this.cols && (this.xAxis.length > parseInt(this.cols) && ([
          {
            show: true,
            type: 'slider',
            orient: 'horizontal',
            xAxisIndex: [0],
            zoomLock: true,
            startValue: 0,
            maxValueSpan: (parseInt(this.cols) - 1),
            ...this.scrollOption
          },
          { type: 'inside', xAxisIndex: [0], zoomOnMouseWheel: false, moveOnMouseMove: true, moveOnMouseWheel: true },
        ])),
      }
    },
  },
  render() {
    const { option = {}, delay = 400, ...attrs } = this.$attrs;
    return (<Aecharts option={{ ...this.option, ...option }} delay={delay} {...{ attrs }} />);
  }
}